import React, {Component} from 'react';
import moment from 'moment';

class LockTimer extends Component {
    constructor(props){
        super(props);

        this.state = {
            timerClass: '',
            userTime: 0,
            testTime: 0,
            lTime: 0,
            progressClass: '',
            progressText: '',
        }
        this.timer = null;
    }

    updateTimer = () => {
        if(!this.props.idle){
            if(this.state.lTime > 0){
                this.setState({lTime: this.state.lTime - 1});
            }else{
                clearInterval(this.timer);
                this.props.onUnlock();
            }
        }

    }

    componentDidMount(){
        if(!this.timer && this.props.start){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({lTime: this.props.start});
        }
    }

    componentDidUpdate(){
        if(!this.timer && this.props.start){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({lTime: this.props.start});
        }
    }

    render(){
        let {lTime} = this.state;

        if(this.props.show){
            return (
                <div className="col-sm-4 text-right" style={{paddingTop: '0px', display: this.state.lTime ? 'block' : 'none'}}>

                        <div className="pull-right">
                            <div className="timer timer-head" style={(this.state.lTime && this.timer) ? {display: 'block'} : {}}>
                                <h1 className={`sm-top-bottom0 font-thin text-danger font-30`}>{moment.utc(moment.duration(lTime * 1000).as('milliseconds')).format('HH:mm:ss')}</h1>

                            </div>


                        </div>

                    </div>
            )
        }else{
            return null;
        }
    }
}

export default LockTimer;


// WEBPACK FOOTER //
// ./src/components/UserCourse/LockTimer.js